import { Controller } from "@hotwired/stimulus";

// Filters the table to one funnel stage and sorts rows within each feed kind, keeping stage and kind headers in place.
export default class extends Controller {
  static targets = ["section", "filter", "sortButton"];

  filter (event) {
    const stage = event.currentTarget.dataset.stage;
    this.sectionTargets.forEach(section => {
      section.classList.toggle("hidden", stage !== "all" && section.dataset.stage !== stage);
    });
    // A stage's tone colour would out-rank text-white, so it comes off while the button is selected.
    this.filterTargets.forEach(button => {
      const active = button.dataset.stage === stage;
      button.setAttribute("aria-pressed", active);
      button.classList.remove(...(active ? button.dataset.tone : "bg-gray-900 text-white border-gray-900").split(" "));
      button.classList.add(...(active ? "bg-gray-900 text-white border-gray-900" : button.dataset.tone).split(" "));
      button.classList.toggle("bg-white", !active);
    });
  }

  sort (event) {
    const button = event.currentTarget;
    const key = button.dataset.sortKey;
    const direction = button.dataset.direction === "asc" ? "desc" : "asc";
    const attribute = `sort${key.charAt(0).toUpperCase()}${key.slice(1)}`;
    const compare = (a, b) => {
      const left = a.dataset[attribute];
      const right = b.dataset[attribute];
      const order = key === "name" ? left.localeCompare(right) : Number(left) - Number(right);
      return direction === "asc" ? order : -order;
    };

    this.sectionTargets.forEach(section => {
      section.querySelectorAll("tr[data-kind-header]").forEach(header => {
        const rows = [...section.querySelectorAll(`tr[data-sort-row][data-kind="${header.dataset.kindHeader}"]`)].sort(compare);
        section.appendChild(header);
        rows.forEach(row => section.appendChild(row));
      });
    });
    this.sortButtonTargets.forEach(other => {
      const active = other === button;
      other.dataset.direction = active ? direction : "";
      other.closest("th").setAttribute("aria-sort", active ? `${direction}ending` : "none");
      other.querySelector("[data-sort-indicator]").textContent = active ? (direction === "asc" ? "▲" : "▼") : "";
    });
  }
}
